import React from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import title from "./title.png";
import "../css/Appointment.css";
import Banner from "./Banner";
import Nav from "./Nav";
import photo from "./images/photo.jpeg";
import pediatrician from"./images/pediatrician.png";
function Appointment() {
  return (
    <div>
      <Nav />
      <center>
        <h4 id="call">For appointment please call the respective clinic: </h4>
        <div id="appointment-grid">
          <center>
            <img id="pediatric-img" src={pediatrician} />
          </center>
          <div id="table-div">
            <table>
              <thead>
                <tr>
                  <th>Clinic</th>
                  <th>Address</th>
                  <th>Phone</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    HAPPY POLY CLINIC
                    <br />
                    (EVERYDAY: 11:30AM ONWARDS)
                  </td>
                  <td>NATAGAR, KOLKATA - 700113</td>
                  <td id="call-cell">
                    <a href="tel:+919831530390">
                      {" "}
                      9831530390
                      <button id="call-now">Call Now</button>
                    </a>

                    <br />
                    <a href="tel:+918910176891">
                      8910176891
                      <button id="call-now">Call Now</button>
                    </a>
                    <br />
                    <a href="tel:+919874226105">
                      9874226105
                      <button id="call-now">Call Now</button>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    RESIDENCE
                    <br />
                    (10:00AM-11:00AM)
                    <br />
                    (7:00PM-8:00PM)
                  </td>
                  <td>
                    PIRTALA AGARPARA
                    <br />
                    DEBEN SEN ROAD
                    <br />
                    KOLKATA - 700109
                  </td>
                  <td id="call-cell">
                    <br />
                    <a href="tel:+919830310787">
                      9830310787
                      <button id="call-now">Call Now</button>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>DAS MEDICAL</td>
                  <td>GHOLA</td>
                  <td id="call-cell">
                    <a href="tel:+919830237671">
                      9830237671 
                      <button id="call-now">Call Now</button>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </center>
    </div>
  );
}

export default Appointment;
